export const enum ContactType {
    Assistant = 0,
    Lawyer    = 1,
    Employee  = 2
}

export interface Contact {
    id          : number,
    firstname   : string,
    lastname    : string,
    email       : string,
    phone       : string,
    jobTitle    : string,
    contactType : ContactType 
}